interface SvgTrendingProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgTrending(props: SvgTrendingProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M20.75 12H19.25V7.81055L13 14.0605L11 12.0605L4.53027 18.5303L3.46973 17.4697L11 9.93945L13 11.9395L18.1895 6.75H14V5.25H20.75V12Z" fill="currentColor" /></svg>;
}